import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { TravelSuggestionSnapshot, Region } from '@appTypes/TravelSuggestionType';
import { Actions, actions } from '@redux/modules/routePlanner';
import { TypedEpic } from './types';

export const getTravelSuggestionsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_TRAVEL_SUGGESTIONS),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getTravelSuggestions.request>[]
    >,
    switchMap(([action]) => {
      const params = { region: action.payload.join(',') };

      return fromApiRequest((signal) =>
        apiClient.get<{ travelSuggestions: TravelSuggestionSnapshot[] }>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].travelSuggestions,
          params,
        }),
      ).pipe(
        map((response) => actions.getTravelSuggestions.success(response.data.travelSuggestions)),
        catchError((err) =>
          of(
            actions.getTravelSuggestions.failure(
              toReduxError(
                err,
                'Beklager, vi har motorproblemer... Kunne ikke hente reiseforslag! Kontakt kundesenteret hvis problemet vedvarer!',
              ),
            ),
          ),
        ),
      );
    }),
  );

export const getRegionsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_REGIONS),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.getRegions.request>[]>,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<{ regions: Region[] }>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].travelSuggestionsRegions,
        }),
      ).pipe(
        map((response) => actions.getRegions.success(response.data.regions)),
        catchError((err) =>
          of(
            actions.getRegions.failure(
              toReduxError(
                err,
                'Beklager, vi har motorproblemer... Kunne ikke hente regioner! Kontakt kundesenteret hvis problemet vedvarer!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [getTravelSuggestionsEpic, getRegionsEpic];
